module.exports = __webpack_public_path__ + "static/media/fase2_1.0027b4e5.jpg";